import { useMap } from "react-leaflet";
import { useEffect, useRef } from "react";
import L from "leaflet"; // using leaftlet instead of react-leaflet (prolly has more control over CSS and better performance for non-deep changes)
//import './App.css';

function CoolingLoops({ mapRef, filteredOptions, polylineRef1, polylineRef2, polylineRef3, polylineRef4, polylineRef5 }) {
    const map = useMap();
    // const polylineRef1 = useRef(null);
    // const polylineRef2 = useRef(null);
    // const polylineRef3 = useRef(null);
    // const polylineRef4 = useRef(null);

    // Cooling loop A: #3023bf
    // Cooling loop B: #c093e9
    // Cooling loop C: #9f2047
    // Cooling loop D: #d1711e
    // Cooling loop QUAD: #2bbbb7



    // function selectedLoopA(options = filteredOptions) {
    //     return options.includes("SAKAMAKI HALL") || options.includes("ART BUILDING") || options.includes("UNIVERSITY HEALTH SERVICES") || options.includes("WATANABE HALL") || options.includes("HOLMES HALL");
    // }

    // function selectedLoopC(options = filteredOptions) {
    //     return options.includes("MOORE HALL") || options.includes("AGRICULTURAL ENGINEERING INSTITUTE") || options.includes("SHERMAN LABORATORY") || options.includes("ST. JOHN PLANT SCIENCE LABORATORY 1 & 2") || options.includes("BIOMEDICAL SCIENCES BUILDING");
    // }

    // function selectedLoopD(options = filteredOptions) {
    //     return options.includes("WEBSTER HALL") || options.includes("SPALDING HALL") || options.includes("EDMONDSON HALL");
    // }

    // function selectedLoopQUAD(options = filteredOptions) {
    //     return options.includes("SAUNDERS HALL") || options.includes("ARCHITECTURE BUILDING") || options.includes("GEORGE HALL") || options.includes("CRAWFORD HALL") || options.includes("HAWAII HALL") || options.includes("QUADRANGLE LOOP BUILDING") || options.includes("GARTLEY HALL") || options.includes("DEAN HALL");
    // }

    useEffect(() => {
        if (!map)   return;

        const coordinatesA = [
                        [
                            [21.298980792168848, -157.81726755596338],
                            [21.29863309308223, -157.81726362150718],
                            [21.29865875320688, -157.81619344943852],
                            [21.297848624263736, -157.81615933196866],
                            [21.29785180644997, -157.8159618848383],
                            [21.297031779875937, -157.81592850877732]
                        ],
                        [
                            [21.297193097672874, -157.81593532494773],
                            [21.297166897266678, -157.81693424103386]
                        ],
                        [
                            [21.298358074486202, -157.81618027129898],
                            [21.298377138457923, -157.815421427519]
                        ],
                        [
                            [21.298366126275965, -157.8158472185688],
                            [21.298296754649, -157.81584426978068]
                        ],
                        // connects to cooling loop B
                        [
                            [21.29865879524945, -157.81619348300995],
                            [21.298659962605285, -157.8161421966371],
                            [21.29919333985322, -157.81616405054885]
                        ]
                    ];
        
        const coordinatesC = [
  [
    [21.303424299751356, -157.81468318376497],
    [21.301443210486042, -157.81460140022904],
    [21.30138689150469, -157.816553537673]
  ],
  // tunnel that connects to sherman laboratory
  [
    [21.302085955303667, -157.814627953601],
    [21.302083318426156, -157.8148580923088]
  ],
  [
    [21.301418212020437, -157.81541662058905],
    [21.301112253156518, -157.8154034848424]
  ],
  [
    [21.301410868721845, -157.81571611542748],
    [21.301662978360284, -157.81572662402488]
  ],
  [
    [21.301662978360284, -157.81613645932097],
    [21.30168990266462, -157.81483864754995]
  ],
  [
    [21.3013870717095, -157.81655283872593],
    [21.300735138289127, -157.81653481896367]
  ]
];    
                    
        const coordinatesD = [
                        [
                            [21.300612124432632, -157.81777051363605],
                            [21.30096586949186, -157.81778331192635],
                            [21.30097779346734, -157.81703674499337],
                            [21.300540580384165, -157.8170132814612],
                            [21.300542567719333, -157.81670612249434]
                        ],
                        [
                            [21.30088621631603, -157.81738842052576],
                            [21.300971688078533, -157.81738842052576]
                        ]
                    ];

        const coordinatesQUAD = [
                        [
                            [21.300636049005547, -157.8194814598383],
                            [21.300635164134903, -157.8195900073836],
                            [21.300292404621032, -157.81958541364375]
                        ],
                        [
                            [21.299798203968166, -157.82072963985047],
                            [21.300401699353387, -157.82074486706495],
                            [21.300406064591314, -157.82038644186363],
                            [21.300404973282184, -157.82047897647442],
                            [21.299897693188356, -157.8204626160721],
                            [21.299912457895132, -157.81900819534118]
                        ],
                        [
                            [21.29990004679712, -157.82022598415418],
                            [21.299533600419622, -157.82021155067315]
                        ],
                        [
                            [21.299910133927582, -157.8192679617041],
                            [21.300367350113646, -157.8192878077404],
                            [21.300635960285206, -157.81948158017963],
                            [21.300634443306123, -157.81925966048078]
                        ]
                    ];

        const coordinatesB = [
      [
        [21.299587861794706, -157.81617890931582],
        [21.29960485938581, -157.81547035664428]
      ],
      [
        [21.29960492791382, -157.81547015378143],
        [21.29931705268919, -157.8154572879172],
        [21.29932111533242, -157.81522621916977]
      ],
      [
        [21.30073532355449, -157.81653492987823],
        [21.30005461109208, -157.81651332872718],
        [21.30006526681568, -157.81619690579552],
        [21.29919349958729, -157.8161639763633],
        [21.29918186612612, -157.81670713137385]
      ],
      [
        [21.300319880169766, -157.81652275942417],
        [21.30032203361533, -157.81633322998178]
      ]
    ];

    // used layer group to include two lines at the same coordiantes
    // layer group itself does not call bindToolTip so well, so call that function on one of the polylines 
        const coolingLoopA = L.layerGroup([
          L.polyline(coordinatesA, {color: "rgb(0, 0, 0)", weight: 5, dashArray: 4}),
          L.polyline(coordinatesA, {color: "#3023bf", dashArray: 4}).bindTooltip("Cooling Loop A") // default weight is 3
        ]);
        coolingLoopA.addTo(map);

        const coolingLoopC = L.layerGroup([
          L.polyline(coordinatesC, {color: "rgb(0, 0, 0)", weight: 5, dashArray: 4}),
          L.polyline(coordinatesC, {color: "#9f2047", dashArray: 4}).bindTooltip("Cooling Loop C")
        ]);
        coolingLoopC.addTo(map);

        const coolingLoopD = L.layerGroup([
          L.polyline(coordinatesD, {color: "rgb(0, 0, 0)", weight: 5, dashArray: 4}),
          L.polyline(coordinatesD, {color: "#d1711e", dashArray: 4}).bindTooltip("Cooling Loop D")
        ]);
        coolingLoopD.addTo(map);

        const coolingLoopQUAD = L.layerGroup([
          L.polyline(coordinatesQUAD, {color: "rgb(0, 0, 0)", weight: 5, dashArray: 4}),
          L.polyline(coordinatesQUAD, {color: "#2bbbb7", dashArray: 4}).bindTooltip("Cooling Loop QUAD")
        ]);
        coolingLoopQUAD.addTo(map);

        const coolingLoopB = L.layerGroup([
          L.polyline(coordinatesB, {color: "rgb(0, 0, 0)", weight: 5, dashArray: 4}),
          L.polyline(coordinatesB, {color: "#c093e9", dashArray: 4}).bindTooltip("Cooling Loop B")
        ]);
        coolingLoopB.addTo(map);

        polylineRef1.current = [];
        polylineRef2.current = [];
        polylineRef3.current = [];
        polylineRef4.current = [];
        polylineRef5.current = [];

        // layer group itself doesn't have path node, only the polygons and lines it stores do

        coolingLoopA.eachLayer(layer => {
          if (layer instanceof L.Polyline && layer._path) {
            polylineRef1.current.push(layer._path);
            // Now you can apply classes or styles
            //polylineRef1.current.classList.add("building-visible");
          }
        });
        console.log(polylineRef1.current);
        coolingLoopC.eachLayer(layer => {
          if (layer instanceof L.Polyline && layer._path) {
            polylineRef2.current.push(layer._path);
            // Now you can apply classes or styles
            //polylineRef1.current.classList.add("building-visible");
          }
        });
        coolingLoopD.eachLayer(layer => {
          if (layer instanceof L.Polyline && layer._path) {
            polylineRef3.current.push(layer._path);
            // Now you can apply classes or styles
            //polylineRef1.current.classList.add("building-visible");
          }
        });
        coolingLoopQUAD.eachLayer(layer => {
          if (layer instanceof L.Polyline && layer._path) {
            polylineRef4.current.push(layer._path);
            // Now you can apply classes or styles
            //polylineRef1.current.classList.add("building-visible");
          }
        });
        coolingLoopB.eachLayer(layer => {
          if (layer instanceof L.Polyline && layer._path) {
            polylineRef5.current.push(layer._path);
            // Now you can apply classes or styles
            //polylineRef1.current.classList.add("building-visible");
          }
        });

        return () => {
            polylineRef1.current = null;
            polylineRef2.current = null;
            polylineRef3.current = null;
            polylineRef4.current = null;
            polylineRef5.current = null;
            map.removeLayer(coolingLoopA);
            map.removeLayer(coolingLoopC);  
            map.removeLayer(coolingLoopD);
            map.removeLayer(coolingLoopQUAD);
            map.removeLayer(coolingLoopB);
            
        };
    }, [map]); 

    // useEffect(() => {
    //     if (!polylineRef1.current) return;
    //     if (!polylineRef2.current) return;
    //     if (!polylineRef3.current) return;
    //     if (!polylineRef4.current) return;

    //     if (selectedLoopA(filteredOptions)) {
    //         polylineRef1.current.classList.remove("unselectBuildingGroup");
    //         polylineRef1.current.classList.add("selectBuildingGroup");
    //     } else {
    //         polylineRef1.current.classList.remove("selectBuildingGroup");
    //         polylineRef1.current.classList.add("unselectBuildingGroup");
    //     }

    //     if (selectedLoopC(filteredOptions)) {
    //         polylineRef2.current.classList.remove("unselectBuildingGroup");
    //         polylineRef2.current.classList.add("selectBuildingGroup");
    //     } else {
    //         polylineRef2.current.classList.remove("selectBuildingGroup");
    //         polylineRef2.current.classList.add("unselectBuildingGroup");
    //     }

    //     if (selectedLoopD(filteredOptions)) {
    //         polylineRef3.current.classList.remove("unselectBuildingGroup");
    //         polylineRef3.current.classList.add("selectBuildingGroup");
    //     } else {
    //         polylineRef3.current.classList.remove("selectBuildingGroup");
    //         polylineRef3.current.classList.add("unselectBuildingGroup");
    //     }

    //     if (selectedLoopQUAD(filteredOptions)) {
    //         polylineRef4.current.classList.remove("unselectBuildingGroup");
    //         polylineRef4.current.classList.add("selectBuildingGroup");
    //     } else {
    //         polylineRef4.current.classList.remove("selectBuildingGroup");
    //         polylineRef4.current.classList.add("unselectBuildingGroup");
    //     }
    // }, [filteredOptions]);

    return null;
}

export default CoolingLoops;